(function () {
  var body = document.body;
  var veil = document.querySelector('[data-sp-veil]');

  var closeAll = function () {
    document.querySelectorAll('[data-sp-drawer].sp-is-open').forEach(function (d) {
      d.classList.remove('sp-is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    body.classList.remove('sp-no-scroll');
    if (veil) {
      veil.classList.remove('sp-is-active');
      window.setTimeout(function () { veil.hidden = true; }, 380);
    }
  };

  var openDrawer = function (id) {
    var drawer = document.querySelector('[data-sp-drawer="' + id + '"]');
    if (!drawer) return;
    if (veil) {
      veil.hidden = false;
      window.requestAnimationFrame(function () { veil.classList.add('sp-is-active'); });
    }
    drawer.classList.add('sp-is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('sp-no-scroll');
    var focusable = drawer.querySelector('input, button, a');
    if (focusable) window.setTimeout(function () { focusable.focus(); }, 340);
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-sp-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.getAttribute('data-sp-drawer-open'));
      return;
    }
    if (event.target.closest('[data-sp-drawer-close]') || event.target === veil) {
      closeAll();
      return;
    }
    var toggle = event.target.closest('[data-sp-submenu]');
    if (toggle) {
      event.preventDefault();
      var item = toggle.closest('[data-sp-submenu-item]');
      if (item) item.classList.toggle('sp-is-open');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-sp-qty]');
    if (!step) return;
    var wrap = step.closest('.sp-qty');
    var input = wrap ? wrap.querySelector('input') : null;
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var current = parseInt(input.value || min, 10);
    var next = step.getAttribute('data-sp-qty') === 'up' ? current + 1 : current - 1;
    input.value = next < min ? min : next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  var formatMoney = function (cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}')
      .replace('{{amount}}', whole + '.' + parts[1])
      .replace('{{amount_no_decimals}}', whole)
      .replace('{{amount_with_comma_separator}}', whole.replace(/,/g, '.') + ',' + parts[1])
      .replace('{{amount_no_decimals_with_comma_separator}}', whole.replace(/,/g, '.'));
  };

  var initProduct = function (root) {
    (root || document).querySelectorAll('[data-sp-product]').forEach(function (form) {
      if (form.hasAttribute('data-sp-ready')) return;
      form.setAttribute('data-sp-ready', 'true');

      var dataEl = form.querySelector('[data-sp-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var money = form.getAttribute('data-money-format') || '${{amount}}';
      var idInput = form.querySelector('[data-sp-variant-id]');
      var priceEl = form.querySelector('[data-sp-price]');
      var compareEl = form.querySelector('[data-sp-compare]');
      var submit = form.querySelector('[data-sp-submit]');
      var stock = form.querySelector('[data-sp-stock]');
      var sku = form.querySelector('[data-sp-sku]');

      var update = function () {
        var chosen = Array.prototype.map.call(form.querySelectorAll('[data-sp-option]'), function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
        var match = variants.filter(function (v) {
          return chosen.every(function (val, i) { return val === null || v.options[i] === val; });
        })[0];
        if (!match) {
          if (submit) {
            submit.disabled = true;
            submit.textContent = submit.getAttribute('data-unavailable') || 'No disponible';
          }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price, money);
        if (compareEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            compareEl.textContent = formatMoney(match.compare_at_price, money);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (sku) sku.textContent = match.sku || '';
        if (stock) {
          stock.textContent = match.available
            ? (stock.getAttribute('data-in') || 'Disponible')
            : (stock.getAttribute('data-out') || 'Agotado');
          stock.classList.toggle('sp-product__stock--out', !match.available);
        }
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available
            ? (submit.getAttribute('data-add') || 'Agregar al carrito')
            : (submit.getAttribute('data-soldout') || 'Agotado');
        }
        if (match.featured_media_id) {
          var thumb = form.closest('.sp-product') ? form.closest('.sp-product').querySelector('[data-sp-thumb="' + match.featured_media_id + '"]') : null;
          if (thumb) thumb.click();
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      };

      form.querySelectorAll('[data-sp-option] input').forEach(function (input) {
        input.addEventListener('change', update);
      });
      update();
    });
  };

  var initGallery = function (root) {
    (root || document).querySelectorAll('[data-sp-gallery]').forEach(function (gallery) {
      if (gallery.hasAttribute('data-sp-ready')) return;
      gallery.setAttribute('data-sp-ready', 'true');
      var stage = gallery.querySelector('[data-sp-stage]');
      gallery.querySelectorAll('[data-sp-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-sp-thumb');
          gallery.querySelectorAll('[data-sp-thumb]').forEach(function (t) { t.classList.remove('sp-is-active'); });
          thumb.classList.add('sp-is-active');
          if (!stage) return;
          stage.querySelectorAll('[data-sp-slide]').forEach(function (slide) {
            slide.hidden = slide.getAttribute('data-sp-slide') !== id;
          });
        });
      });
    });
  };

  var initHeader = function () {
    var header = document.querySelector('[data-sp-header-shrink]');
    if (!header) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('sp-is-scrolled', y > 40);
      last = y;
    }, { passive: true });
  };

  var initAnnouncement = function (root) {
    (root || document).querySelectorAll('[data-sp-rotate]').forEach(function (wrap) {
      if (wrap.hasAttribute('data-sp-ready')) return;
      wrap.setAttribute('data-sp-ready', 'true');
      var items = wrap.querySelectorAll('.sp-announcement__item');
      if (items.length < 2) return;
      var delay = parseInt(wrap.getAttribute('data-sp-rotate'), 10) || 5;
      var index = 0;
      window.setInterval(function () {
        items[index].classList.remove('sp-is-active');
        index = (index + 1) % items.length;
        items[index].classList.add('sp-is-active');
      }, delay * 1000);
    });
  };

  var init = function (root) {
    initProduct(root);
    initGallery(root);
    initAnnouncement(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); initHeader(); });
  } else {
    init(document);
    initHeader();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
